import { fetchEntity } from './entity';

export const fetchMessagetypes = () => fetchEntity({ entityName: 'messagetypes', fetchUrl: '/api/wallet/privatemessagetype/get' });
